// src/context/UrlContext.jsx
import React, { createContext, useMemo } from "react";

export const UrlContext = createContext();

const trimTrailingSlash = (value) => value.replace(/\/+$/, "");

const getApiBaseUrl = () => {
  const envApiUrl = process.env.REACT_APP_API_URL?.trim();

  if (envApiUrl) {
    return trimTrailingSlash(envApiUrl);
  }

  if (typeof window !== "undefined") {
    const { hostname, origin } = window.location;

    if (hostname !== "localhost" && hostname !== "127.0.0.1") {
      return `${origin}/api`;
    }
  }

  return "http://localhost:5002/api";
};

export const UrlProvider = ({ children }) => {
  const apiBaseUrl = useMemo(() => getApiBaseUrl(), []);
  const url = useMemo(() => apiBaseUrl.replace(/^https?:\/\//, ""), [apiBaseUrl]);

  return (
    <UrlContext.Provider value={{ url, apiBaseUrl }}>
      {children}
    </UrlContext.Provider>
  );
};
